// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2052g","paymentContainer":"PaymentPage_paymentContainer__3kbhC"};